import { render } from "./AdDetail.vue?vue&type=template&id=050ba0a2&scoped=true"
import script from "./AdDetail.vue?vue&type=script&lang=js"
export * from "./AdDetail.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_ad.css?vue&type=style&index=0&id=050ba0a2&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050ba0a2"]])

export default __exports__